<template>
	<div class="category">
		<select
			@change="setFirstCategory"
			v-model="getCategoryIds.idFirstCategory"
			class="category__select"
			aria-label="1st category"
		>
			<option :value="null">-- 1차 카테고리 --</option>
			<option
				v-for="category in getCategoryList(1)"
				:key="category.idFirstCategory"
				:value="category.idFirstCategory"
			>
				{{ category.firstCategoryText }}
			</option>
		</select>
		<select
			@change="setSecondCategory"
			v-model="getCategoryIds.idSecondCategory"
			class="category__select"
			aria-label="2nd category"
		>
			<option :value="null">-- 2차 카테고리 --</option>
			<option
				v-for="category in getCategoryList(2)"
				:key="category.idSecondCategory"
				:value="category.idSecondCategory"
			>
				{{ category.secondCategoryText }}
			</option>
		</select>
		<select
			@change="setThirdCategory"
			v-model="getCategoryIds.idThirdCategory"
			class="category__select"
			aria-label="3rd category"
			:disabled="isThirdCategoryDisabled"
		>
			<option :value="null">-- 3차 카테고리 --</option>
			<option v-if="showMergedChildren" value="all">전체</option>
			<option
				v-for="category in getCategoryList(3)"
				:key="category.idThirdCategory"
				:value="category.idThirdCategory"
			>
				{{ category.thirdCategoryText }}
			</option>
		</select>
	</div>
</template>
<script>
	import _ from 'lodash';

	export default {
		name: 'SingleCategorySelector',
		props: {
			value: {
				type: Object,
				default() {
					return {
						idFirstCategory: null,
						idSecondCategory: null,
						idThirdCategory: null,
					};
				},
			},
			showDisplayFalse: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				categoryIds: this.value,
				showMergedChildren: false,
				firstCategories: [],
				secondCategories: [],
				thirdCategories: [],
			};
		},
		mounted() {
			this.getCategories('firstCategories', 1);
			this.$emit('mounted', this.setCategories);
		},
		computed: {
			getCategoryList() {
				return step => {
					if (step === 1) {
						return this.firstCategories;
					} else if (step === 2) {
						return this.secondCategories;
					} else if (step === 3) {
						return this.thirdCategories;
					}
				};
			},
			getCategoryIds() {
				return this.value;
			},
			isThirdCategoryDisabled() {
				return (
					this.getCategoryIds.idSecondCategory !== null &&
					this.getCategoryList(3).length === 0
				);
			},
		},
		methods: {
			init() {
				this.secondCategories = [];
				this.thirdCategories = [];
				this.showMergedChildren = false;
			},
			async getCategories(target, step, parent = '') {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/categories/level/${step}/simple?idParentCategory=${parent}`
					);

					if (this.showDisplayFalse) {
						this[target] = data.data;
					} else {
						this[target] = data.data.filter(
							category => category.isDisplay
						);
					}
				} catch (error) {
					console.error(error);
				}
			},
			async setCategories() {
				await this.getCategories(
					'secondCategories',
					2,
					this.categoryIds.idFirstCategory
				);
				await this.getCategories(
					'thirdCategories',
					3,
					this.categoryIds.idSecondCategory
				);
			},
			async setFirstCategory(event) {
				if (event.target.value) {
					await this.getCategories(
						'secondCategories',
						2,
						event.target.value
					);

					this.thirdCategories = [];
				} else {
					this.secondCategories = [];
					this.thirdCategories = [];
				}

				this.categoryIds.idFirstCategory = event.target.value
					? event.target.value
					: null;
				this.categoryIds.idSecondCategory = null;
				this.categoryIds.idThirdCategory = null;

				this.emitValues();
			},
			async setSecondCategory(event) {
				if (event.target.value) {
					await this.getCategories(
						'thirdCategories',
						3,
						event.target.value
					);
				} else {
					this.thirdCategories = [];
				}
				this.categoryIds.idSecondCategory = event.target.value
					? event.target.value
					: null;
				this.categoryIds.idThirdCategory = null;

				this.showMergedChildren = _.find(this.secondCategories, {
					idSecondCategory: Number(event.target.value),
				}).showMergedChildren;

				this.emitValues();
			},
			setThirdCategory(event) {
				this.categoryIds.idThirdCategory = event.target.value
					? event.target.value
					: null;
				this.emitValues();
			},
			emitValues() {
				const params = {
					...this.categoryIds,
					thirdCategoryLength: this.thirdCategories.length,
				};
				this.$emit('input', params);
			},
		},
	};
</script>
<style lang="scss">
	DIV {
		.category__select {
			display: inline-block;
			width: 32%;
			margin-right: 1.33333%;
			height: 36px;
			background: #fff;
			border: solid 1px #dfe6ee;
			border-radius: 4px;
			font-size: 0.875rem;

			&:last-child {
				margin-right: 0;
			}
		}
	}
</style>
